import React, { useState, useEffect, FC } from 'react';
import user from 'assets/img/icons/ic-user.svg';
import user2 from 'assets/img/icons/ic-raisehand.svg';
import user3 from 'assets/img/icons/ic-price.svg';
import user5 from 'assets/img/icons/ic-descuento.svg';
import { Box, Grid } from '@material-ui/core';
import clsx from 'clsx';
import { parsePriceByCurrencyJustSymbol } from '../../../../config/utils/currencyUtils';
import { Currency } from '../../../../models/Currency';
import { Ticket } from '../../../../models/Ticket';
import { useStyles } from './styles';

interface Props {
    currency: Currency;
    upcoming: boolean;
    ticket: Ticket;
    event_num_attendees: number;
    event_price_ticket: number;
    ticket_streaming: Ticket;
    event_num_attendees_streaming: number;
    event_price_ticket_streaming: number;
    event_promotional_code_discount: number;
    isMobile?: boolean;
}

const PrivateEventInfo: FC<Props> = ({
    currency,
    upcoming,
    ticket,
    ticket_streaming,
    event_num_attendees,
    event_num_attendees_streaming,
    event_price_ticket,
    event_price_ticket_streaming,
    event_promotional_code_discount,
    isMobile,
}) => {
    const classes = useStyles();

    const [grossRev, setGrossRev] = useState<number>(0);
    const [fee, setFee] = useState<string>('');

    useEffect(() => {
        if (ticket) {
            setGrossRev(event_num_attendees * event_price_ticket);

            setFee(
                (ticket.gotmy_min_ticket_fee + ticket.gotmy_ticket_fee * 0.01 * event_price_ticket).toFixed(
                    2,
                ),
            );
        } else if (ticket_streaming) {
            setGrossRev(event_num_attendees_streaming * event_price_ticket_streaming);

            setFee(
                (
                    ticket_streaming.gotmy_min_ticket_fee +
                    ticket_streaming.gotmy_ticket_fee * 0.01 * event_price_ticket_streaming
                ).toFixed(2),
            );
        }
    }, [
        event_num_attendees,
        event_num_attendees_streaming,
        event_price_ticket,
        event_price_ticket_streaming,
        ticket,
        ticket_streaming,
    ]);

    return (
        <Grid container direction={isMobile ? 'column' : 'row'} className={classes.container}>
            <Grid item md={1} />
            <Grid item className={classes.topBorder} md={3}>
                <p className={classes.title}>Private Information</p>
                <div className={classes.infoRow}>
                    <img src={user} alt="" />
                    <div>
                        <p>Price per ticket</p>
                        <p className={classes.infoText}>
                            {event_price_ticket
                                ? parsePriceByCurrencyJustSymbol(event_price_ticket?.toString(), currency)
                                : parsePriceByCurrencyJustSymbol(
                                      event_price_ticket_streaming?.toString(),
                                      currency,
                                  )}
                        </p>
                    </div>
                </div>
                <div className={classes.infoRow}>
                    <img src={user2} alt="" />
                    <div>
                        <p>Number of tickets</p>
                        <p className={classes.infoText}>
                            {event_num_attendees !== null
                                ? event_num_attendees
                                : event_num_attendees_streaming}
                        </p>
                    </div>
                </div>
                <div className={classes.infoRow}>
                    <img src={user3} alt="" />
                    <div>
                        <p>Gross Revenue (sold out)</p>
                        <p className={classes.infoText}>$ {grossRev}</p>
                    </div>
                </div>
                <div className={classes.infoRow}>
                    <img src={user} alt="" />
                    <div>
                        <p>Ticketing Fees</p>
                        <p className={classes.infoText}>$ {fee}</p>
                    </div>
                </div>
                <div className={classes.infoRow}>
                    <img src={user5} alt="" />
                    <div>
                        <p>Discount Code</p>
                        <p className={classes.infoText}> {event_promotional_code_discount}%</p>
                    </div>
                </div>
            </Grid>

            <Grid item md={8}>
                <Box className={clsx(classes.policies, classes.topBorder)}>
                    <h4>Rescheduling policy</h4>
                    <p>
                        Once per event, to a later date/time and up to 24 hours before the event any viewer
                        can ask refund anytime and your score shall be affected
                    </p>

                    <h4>Cancellation policy</h4>
                    <p>
                        Up to 24 hours before the event, viewers will get full refund and your score shall be
                        affected.
                    </p>

                    <h4>Influencer's delay longer than 10 minutes or no-show</h4>
                    <p>Viewer will get full refund and your score shall be heavily affected</p>
                    {upcoming && (
                        <a
                            href="mailto:support@gotmy.com?subject=Event cancellation"
                            className={classes.cancelButton}
                        >
                            Cancel live event
                        </a>
                    )}
                </Box>
            </Grid>
        </Grid>
    );
};
export default PrivateEventInfo;
